import "./style.css";
import img from "../../Images/logo.png";
import React from "react";
import { Link } from "react-router-dom";
export function Header() {
  const handleClick = () => {
    const doc = document.getElementById("mainMenu");
    if (!doc.classList.contains("active")) {
      doc.classList.add("active");
      const div = document.createElement("div");
      div.classList.add("backdrop");
      div.addEventListener("click", handleClose);
      document.body.appendChild(div);
    }
  };
  const handleClose = () => {
    const doc = document.getElementById("mainMenu");
    if (doc.classList.contains("active")) {
      doc.classList.remove("active");
      const doc1 = document.getElementsByClassName("backdrop");
      doc1[0].removeEventListener("click", null);
      doc1.length && document.body.removeChild(doc1[0]);
    }
  };
  return (
    <>
      <div
        className="header-top-bar top-bar-border-bottom bg-light-primary100 d-none d-md-block"
        style={{ background: "#797979" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-3 d-none d-xl-block">
              <p className="Care-for-Humanity">Care For Humanity</p>
            </div>
            <div className="col-xl-9 col-lg-12 col-md-12 col-12 header-contact-layout1">
              <ul className="ml-15">
                <li style={{ borderRight: "none" }}>
                  <span className="mt-5">
                    <i className="bi bi-envelope"></i>
                  </span>{" "}
                  info@krufrenpharma.com
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <header>
        <div>
          <button className="navbar-toggler " onClick={() => handleClick()}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              className="bi bi-list"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
              />
            </svg>
          </button>
          <img src={img} alt="krufren logo" className="krufren-logo"></img>
        </div>
        <div className="header-navbar-wrapper" id="mainMenu">
          <div className="close-button-wrapper">
            <button className="close-button" onClick={() => handleClose()}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                className="bi bi-x-circle-fill"
                viewBox="0 0 16 16"
              >
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
              </svg>
            </button>
          </div>

          <ul className="header-navbar">
            <li className="header-navbar-item">
              <Link to="/" onClick={() => handleClose()}>
                Home
              </Link>
            </li>

            <li className="header-navbar-item has-submenu">
              <div>About Us</div>
              <div className="submenu">
                <Link onClick={() => handleClose()} to="/vision-value">
                  Vision & Values
                </Link>
                <Link onClick={() => handleClose()} to="/quality">
                  Quality
                </Link>
              </div>
            </li>
            <li className="header-navbar-item has-submenu">
              <div>Facility</div>
              <div className="submenu">
                <Link onClick={() => handleClose()} to="/manufacturing">
                  Manufacturing
                </Link>
                <Link onClick={() => handleClose()} to="/api">
                  API Manufacturing
                </Link>
                <Link onClick={() => handleClose()} to="/research-development">
                  R & D
                </Link>
                <Link
                  onClick={() => handleClose()}
                  to="/analytical-development"
                >
                  Analytical Development
                </Link>
              </div>
            </li>
            <li className="header-navbar-item has-submenu">
              <div>Products</div>
              <div className="submenu">
                <Link onClick={() => handleClose()} to="/pipeline">
                  Product Under Pipeline
                </Link>
              </div>
            </li>
            <li className="header-navbar-item has-submenu">
              <div>Responsibility</div>
              <div className="submenu">
                <Link onClick={() => handleClose()} to="/ehs">
                  EHS
                </Link>
                <Link onClick={() => handleClose()} to="/csr">
                  CSR
                </Link>
              </div>
            </li>
            <li className="header-navbar-item">
              <Link onClick={() => handleClose()} to="/contact">
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </header>
    </>
  );
}
